import { FC } from "react";
import {
  Control,
  Controller,
  FieldValues,
  UseFormSetValue,
} from "react-hook-form";

import { PriceRateAdditionPricingType } from "@ryde/shared";

import { PriceLevelItem } from "./price-level-item";

interface IPriceLevelRowProps {
  fieldName: string;
  index: number;
  pricingType: PriceRateAdditionPricingType;
  fromValues: number[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parentControl: Control<FieldValues, any>;
  parentSetValue: UseFormSetValue<FieldValues>;
  removeHandler: (index: number) => void;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

export const PriceLevelRow: FC<IPriceLevelRowProps> = ({
  fieldName,
  index,
  pricingType,
  fromValues,
  parentControl,
  parentSetValue,
  removeHandler,
  disabledEdit,
  disabledRemove,
}) => {
  return (
    <Controller
      name={`${fieldName}[${index}]`}
      control={parentControl}
      render={({ field: { value: itemValue } }) => (
        <PriceLevelItem
          fieldName={`${fieldName}[${index || 0}]`}
          index={index}
          pricingType={pricingType}
          fromValues={fromValues}
          value={itemValue}
          removeHandler={removeHandler}
          setValueOuter={parentSetValue}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
        />
      )}
    />
  );
};
